/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_AltInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_alt = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft grade tracker with calculated averages and the Formulas ribbon`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_alt = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 成绩跟踪表，显示平均分计算结果与 Formulas 功能区`)
};

/**
* | output |
* | --- |
* | "GridCraft grade tracker with calculated averages and the Formulas ribbon" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_alt = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_alt(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_alt(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_alt as "gc.search_guides.gridcraft_excel_compatibility.sections.2.figure.alt" }